// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a980a0f2","952":"adeb93aa"}[chunkId] + ".chunk.js";
};